'use client'

import { useSearchParams } from 'next/navigation'

/**
 * Copied from https://github.com/algolia/instantsearch/blob/fd04dcaea1ffd49b2c43e9286f6dfda47c4808f9/packages/algoliasearch-helper/src/utils/isValidUserToken.js#L7
 */
const userTokenPattern = /^[a-zA-Z0-9_-]{1,64}$/u

/**
 * Return `userToken` for Algolia Analytics if it's valid.
 * Prevent logging of invalid tokens in the console (https://github.com/algolia/instantsearch/blob/9bc841a12ee466d981f9ce2f20e17dbc74ca6b44/packages/algoliasearch-helper/src/SearchParameters/index.js#L102-L107).
 *
 * The current approach relies on the query string for providing `userToken`.
 * At the same time, there is a ticket https://jira.shop-apotheke.com/browse/WSAWA-7084
 * to use cookie value instead, so implementation could be changed in the future.
 */
export const useAlgoliaUserToken = (): string | undefined => {
  const searchParams = useSearchParams()

  const userToken = searchParams.get('userToken')

  if (userToken && userTokenPattern.test(userToken)) {
    return userToken
  }

  return undefined
}
